/* @flow */

import { connect } from 'react-redux'

import type { RootState } from '../types'

import { hasDmpPermissions } from '../stores/usersStore'
import { selectCurrentUser } from '../stores/currentUser'
import Condition from './Condition'

type StateProps = {
  shouldRender: boolean,
}

function mapStateToProps(state: RootState, ownProps: Object): StateProps {
  const currentUser = selectCurrentUser(state)
  return {
    shouldRender:
      currentUser != null &&
      (!ownProps.poll.dmpIntegration ||
        (hasDmpPermissions(currentUser) && ownProps.poll.dmpIntegration)),
  }
}

export default connect(mapStateToProps)(Condition)



// WEBPACK FOOTER //
// ./src/components/IfDmpAccess.js